import * as Styled from './styled';
import { IBaseImage } from '@/lib/notebooks/notebooksApi';
import Input from '@/components/Input';
import { useState } from 'react';

type BaseImageSelectProps = {
  baseImageList: IBaseImage[];
  selectedId?: string;
  onChange: (id: string) => void;
};

const BaseImageOption = (props: any) => {
  const { innerProps, data, getStyles } = props;
  return (
    <div style={getStyles('option', props)} {...innerProps}>
      <div>{data.image_definition}</div>
      <small>{data.description}</small>
    </div>
  );
};

// Force the menu to be constrained to the height of the container
const BaseImageMenu = (props: any) => {
  const { innerProps, data, getStyles } = props;
  return (
    <div style={{ ...getStyles('menu', props), maxHeight: '250px', overflowY: 'auto' }} {...innerProps}>
      {props.children}
    </div>
  );
};

const BaseImageSelect: React.FC<BaseImageSelectProps> = ({
  baseImageList,
  selectedId,
  onChange = (v) => {
    console.log(v);
  },
}) => {
  const [selectedBaseImageId, setSelectedBaseImageId] = useState<string | undefined>(selectedId);

  return (
    <Styled.BaseImageSelect>
      <Input.Select
        name="baseImage"
        // menuIsOpen={true}
        label="Base Image"
        placeholder="Search"
        selectedValue={selectedBaseImageId}
        customComponents={{
          Option: BaseImageOption,
          Menu: BaseImageMenu,
        }}
        options={baseImageList.map((baseImage) => ({
          ...baseImage,
          label: baseImage.image_definition,
          value: baseImage.id,
        }))}
        wide
        onChange={(value) => {
          setSelectedBaseImageId(value);
          onChange(value);
        }}
      />
    </Styled.BaseImageSelect>
  );
};

export default BaseImageSelect;
